/**
 * Created by renlaydel on 02/11/2017.
 */
import * as apiUtil from '../../apiUtils';
import * as apiCommon from '../../apiCommon';

import { PURCHASE_RECEIPT } from '../../../constants/constant_doc_types';
import { setLineItemId } from '../../inventory/helper_inventory';

export const savePurchaseReceipt = async (app, params) => {
  const { data, user = {}, skip_low_qty } = params;

  let purchaseReceipt = {
    _id: data.id,
    doc_type: PURCHASE_RECEIPT,
    restart: data.restart,
    location_id: data.location_id,
    location_type: data.location_type,
    supplier_id: data.supplier_id,
    subsidiary_id: data.subsidiary_id,
    currency_id: data.currency_id,
    exchange_rate: data.exchange_rate,
    purchase_order_id: data.purchase_order_id,
    receipt_date: apiUtil.toUtcDate(data.receipt_date),
    dispatched_date: apiUtil.toUtcDate(data.dispatched_date),
    reference_id: data.reference_id,
    status_id: data.status_id,
    status: data.status,
    reference_number: data.reference_number,
    notes: data.notes,
    lines: data.lines,
    tax: data.tax,
    custom_fields: data.custom_fields,
  };

  // const currencyCode = (data.currency || {}).code;

  purchaseReceipt.lines = (purchaseReceipt.lines || []).map((line) => {
    // line.unit_cost = apiUtil.toCurrency(line.unit_cost, true, currencyCode);
    // line.total = apiUtil.toCurrency(line.total, true, currencyCode);
    // line.total_ex_tax = apiUtil.toCurrency(
    //   line.total_ex_tax,
    //   true,
    //   currencyCode,
    // );
    delete line.isFetchingItemLocation;
    delete line.isFetchingTaxGroup;
    delete line.onEditMode;

    line.reference_ids = (line.reference_ids || []).map((referenceId) => {
      delete referenceId.onRefLineEditMode;
      referenceId.expiry_date = apiUtil.toUtcDate(referenceId.expiry_date);
      return referenceId;
    });

    line.item_id = line.item_id.split(':')[0];
    return line;
  });

  let url = purchaseReceipt.doc_type;
  if (data.process) {
    url = 'purchase_receipt/process';
  }

  if (data.abandon) {
    url = 'purchase_receipt/abandon';
  }

  const qParams = {
    skip_low_qty,
  };
  const result = await apiCommon.saveDoc(
    app,
    {
      user,
      doc: purchaseReceipt,
      params: qParams,
      source: data,
    },
    url,
  );
  setLineItemId(result);
  return result;
};

export const fetchPurchaseReceiptById = async(app, params) => {
  const { id } = params;
  const result = await apiCommon.getDoc(
    app,
    { id, docType: PURCHASE_RECEIPT },
    { assemble_custom_fields: true }
  );
  setLineItemId(result);
  return result;
};
